import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../../../core';
import { ClienteIpi } from '../cliente-ipi';

@Injectable({
    providedIn: 'root'
})
export class ClienteIpiHttpService {
    private pathApi: string;

    constructor(private configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/cliente`;
    }

    /** Obtem o IPI do cliente */
    getIpi(id: number): Observable<ClienteIpi> {
        return this.customHttp.get<ClienteIpi>(`${this.pathApi}/${id}/ipi`);
    }
}
